import React, { useEffect, useCallback, useMemo, useRef } from 'react';
import helpers from './helpers';
import { ClientOnlyContent } from '../../../../components/atoms/ClientOnlyContent';
export default function FinanceAdsIframe(_a) {
    var loanAmount = _a.loanAmount, placementId = _a.placementId, onLoaded = _a.onLoaded;
    var ref = useRef(null);
    var src = useMemo(function () {
        return helpers.getIframeSrc(loanAmount, placementId);
    }, [loanAmount, placementId]);
    var handleResizeMessage = useCallback(function (ev) {
        if (ref.current && helpers.isResizeMessage(ev)) {
            var height = ev.data.split(':')[1];
            ref.current.style.height = "".concat(height, "px");
        }
    }, []);
    var handleLoad = useCallback(function () {
        if (ref.current && ref.current.contentWindow) {
            ref.current.contentWindow.postMessage(helpers.getInitialMessage(), '*');
        }
        onLoaded(true);
    }, []);
    useEffect(function () {
        window.addEventListener('message', handleResizeMessage);
        return function () {
            window.removeEventListener('message', handleResizeMessage);
        };
    }, []);
    return (React.createElement(ClientOnlyContent, null,
        React.createElement("iframe", { src: src, ref: ref, seamless: true, onLoad: handleLoad, frameBorder: "0", height: "500px", scrolling: "no", style: { width: '100%' } })));
}
